import type { GlobalSearchPlatform } from "./types";
import type { NetworkPayload } from "../../../composites";

export const API = {
  createSearch: (
    query: string,
    platform: GlobalSearchPlatform,
  ): NetworkPayload => {
    return {
      url: "search",
      options: {
        method: "POST",
        payload: {
          query,
          platform,
        },
        isJsonResponse: true,
      },
    };
  },
  getRecentSearches: (): NetworkPayload => {
    return {
      url: "search/recent",
      options: {
        method: "GET",
        isJsonResponse: true,
      },
    };
  },
  replayRecentSearch: (searchId: string): NetworkPayload => {
    return {
      url: `search/recent/${searchId}`,
      options: {
        method: "GET",
        isJsonResponse: true,
      },
    };
  },
  deleteRecentSearch: (searchId: string): NetworkPayload => {
    return {
      url: `search/recent/${searchId}`,
      options: {
        method: "DELETE",
        isJsonResponse: false,
      },
    };
  },
};
